import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { RefundsListPage } from '../../../features/refunds/refunds-list-page'
import { refundSearchSchema } from '../../../features/refunds/search'

export const Route = createFileRoute('/_app/refunds/')({
  validateSearch: refundSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'sales.read'),
  component: RefundsListPage,
})
